function setGACounter(data) {
    const gtag = window.gtag

    if (!gtag || !data.counter)
        return;

    gtag('event', data.action, {
        send_to: data.counter,
        'event_category': data.category,
        'event_label': data.label,
        'value': data.value
    });
}

export default (data) => { setGACounter(data) }